export default "__VITE_ASSET__c75814ed__"